// import { useEffect, useState } from "react";

// export const useDeviceType = () => {
//   const initialDevice =
//     window.__DEVICE_TYPE__ ||
//     (window.innerWidth <= 767
//       ? "mobile"
//       : window.innerWidth <= 1024
//       ? "tablet"
//       : "desktop");

//   const [device, setDevice] = useState(initialDevice);

//   useEffect(() => {
//     const handleResize = () => {
//       const width = window.innerWidth;

//       if (width <= 767) setDevice("mobile");
//       else if (width <= 1024) setDevice("tablet");
//       else setDevice("desktop");
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   return device;
// };


import { useEffect, useState } from "react";
export const useDeviceType = () => {
  const getDevice = () => {
    if (typeof window === "undefined") return "desktop";

    const width = window.innerWidth;
    if (width < 600) return "mobile";
    if (width < 900) return "tablet";
    return "desktop";
  };

  const [device, setDevice] = useState(getDevice);

  useEffect(() => {
    const handleResize = () => setDevice(getDevice());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return device;
};
